import Swiper, { Navigation, Pagination, Thumbs } from "swiper";
import { initIntersectionObserver } from "@plugins";

Swiper.use([Navigation, Pagination, Thumbs]);

const benefitSections = document.querySelectorAll(".js-benefits-swiper-init");

if (benefitSections) {
    for (const section of benefitSections) {
        initIntersectionObserver(section, initSlider);
    }
}

function initSlider(section) {
    const benefitsThumbsContainer = section.querySelector(".js-benefits-swiper-thumbs");
    const benefitsSliderContainer = section.querySelector(".js-benefits-swiper-container");

    const benefitsThumbsSwiper = new Swiper(benefitsThumbsContainer, {
        fill: "row",
        slidesPerView: "auto",
        observer: true,
        observeParents: true,
        allowTouchMove: false,
    });

    const nextEl = section.querySelector(".js-benefits-swiper-controls > .swiper-button-next");
    const prevEl = section.querySelector(".js-benefits-swiper-controls > .swiper-button-prev");
    const pagination = section.querySelector(".js-benefits-swiper-controls > .swiper-pagination");

    new Swiper(benefitsSliderContainer, {
        spaceBetween: 16,
        observer: true,
        observeParents: true,
        preventInteractionOnTransition: !window.mobileMedia,
        navigation: {
            nextEl,
            prevEl,
        },
        pagination: {
            el: pagination,
            dynamicBullets: true,
            dynamicMainBullets: 3,
            clickable: true,
        },
        thumbs: {
            swiper: benefitsThumbsSwiper,
            autoScrollOffset: 0.5,
        },
        on: {
            touchStart() {
                if (window.mobileMedia) {
                    benefitsThumbsContainer.classList.remove("active");
                }
            },
        },
    });

    if (window.mobileMedia && benefitsThumbsContainer) {
        document.addEventListener("click", (e) => {
            if (!benefitsThumbsContainer.contains(e.target)) {
                benefitsThumbsContainer.classList.remove("active");
            }
        });

        benefitsThumbsContainer.addEventListener("click", () => {
            benefitsThumbsContainer.classList.toggle("active");
        });
    }
}
